module.exports = __webpack_public_path__ + "static/media/ExamMath.cbaff3bd.svg";